<forge-label-value [inline]="isInline" [ngStyle]="alignment" [ngClass]="{'full': !isInline}">
  <div slot="label">{{label}}</div>
  @if (!boolean) {
    <span slot="value">
      @if (!loading) {
        <truncate-text [mainText]="value" class="metadata-label-value--value">
        </truncate-text>
      }
    </span>
  }
  @if (boolean && !loading) {
    <span slot="value">
      <forge-icon [hidden]="!showCheck" name="check" class="grid-icon"></forge-icon>
    </span>
  }
</forge-label-value>
